import { makeAutoObservable, runInAction } from "mobx";

export default class subcategoryStore {
  subcategory = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.subcategory = [];
    runInAction(() => {
      this.subcategory = data;
    });
  };

  deleteSubcategory = (id) => {
    let newState = this.subcategory.filter((subcategory) => subcategory.id !== id);
    this.subcategory = [];
    this.subcategory = newState;
  };
}